export default __webpack_public_path__ + "static/media/canvasAndFramedLargeCanvasFramedOak.4bc4d813.jpg";